.row {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}

.head {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: var(--space-3);
}

.heading {
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
}

.title {
	margin: 0;
	font-size: 1.05rem;
}

.subtitle {
	margin: 0;
	font-size: 0.8rem;
	color: var(--ink-muted);
}

.seeAll {
	flex: none;
	display: inline-flex;
	align-items: center;
	gap: 2px;
	padding: 0;
	background: none;
	border: none;
	color: var(--accent-sage);
	font: inherit;
	font-size: 0.85rem;
	cursor: pointer;
}

/* Single-row horizontal scroller of feature cards. It bleeds to the screen
   edges (matching the filter bar) so cards slide under the page padding, while
   scroll-padding keeps the snap stops aligned with the content — i.e. the first
   card lines up under the title. */
.scroll {
	list-style: none;
	margin: 0 calc(-1 * var(--space-5));
	padding: var(--space-1) var(--space-5);
	scroll-padding-inline: var(--space-5);
	display: grid;
	grid-auto-flow: column;
	grid-template-rows: auto;
	grid-auto-columns: 240px;
	gap: var(--space-3);
	overflow-x: auto;
	scroll-snap-type: x mandatory;
	scrollbar-width: none;
}

.scroll::-webkit-scrollbar {
	display: none;
}

.item {
	scroll-snap-align: start;
}

@media (max-width: 640px) {
	.scroll {
		grid-auto-columns: 220px;
	}
}
